function PanelStatCard({ statKey, label, value, change, variant, icon: Icon }) {
  const toneClass = variant === 'warning' ? 'rec-panel-stat-warning rec-dash-stat-warning' : '';
  return (
    <div className={`owner-stat-card rec-panel-stat rec-dash-stat rec-panel-stat-${statKey} rec-dash-stat-${statKey} ${toneClass}`}>
      {Icon && (
        <div className="rec-panel-stat-icon rec-dash-stat-icon" aria-hidden="true">
          <Icon />
        </div>
      )}
      <div className="rec-panel-stat-content rec-dash-stat-content">
        <div className="owner-stat-label">{label}</div>
        <div className={`owner-stat-value${variant === 'warning' ? ' owner-stat-value-warning' : ''}`}>
          {value}
        </div>
        {change != null && change !== '' && (
          <div className="owner-stat-change">{change}</div>
        )}
      </div>
    </div>
  );
}

export default PanelStatCard;
